export default {
  TEXT: 'text',
  INLINE: 'inline',
  BLOCK: 'block',
  FIGURE: 'figure',
  IMAGE: 'image',
  TABLE: 'table',
  TABLE_ROW: 'table_row',
  TABLE_CELL: 'table_cell',
  CAPTION: 'caption',
  FIGURE_CAPTION: 'figcaption',
  PARAGRAPH: 'paragraph',
  EQUATION: 'equation',
  SPAN: 'span',
  LIST_ITEM: 'list-item',
  NUMBERED_LIST: 'numbered-list',
  BULLETED_LIST: 'bulleted-list',
  HEADING: 'heading',
  SUB_HEADING: 'sub-heading',
};
